//import axios from 'axios'
import api from './axiosConfig'

export const userApi = {

    searchUsers({ search, page, perPage } = {}) {
        return api
            .get('/user/search?search=' + search + '&page=' + page + '&perPage=' + perPage)
            .then((response) => {
                return response.data
            })
    },
	
    createUser({ name, email, password, blocked, customerId } = {}) {
        return api
            .post('/user', { name, email, password, blocked, customerId }, {})
            .then((response) => {
                return response.data
            })
    },
	
    updateUser({ id, name, email, password, blocked, customerId } = {}) {
        return api
            .put('/user', { id, name, email, password, blocked, customerId }, {})
            .then((response) => {
                return response.data
            })
    }, 		
	
    getUser({ id } = {}) {
        return api
            .get('/user?id=' + id)
            .then((response) => {
                return response.data
            })
    },	
}
